import { createStore } from "zustand/vanilla";

import type { WidgetElementsBookingElementDialogEnterSide } from "@/elements/widget/elements/booking-element/dialog/widget-elements-booking-element-dialog";

export interface BookingElementState {
  activePropertyId?: string | undefined;
  isDialogOpen: boolean;
  dialogEnterSide?: WidgetElementsBookingElementDialogEnterSide | undefined;
}

export const bookingElementStore = createStore<BookingElementState>(() => ({
  isDialogOpen: false,
}));
